module.exports = __webpack_public_path__ + "static/fonts/webhostinghub-glyphs.489674a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/webhostinghub-glyphs.eot
// module id = 250
// module chunks = 0